import React, { useState } from "react";
import { Route, useLocation } from "react-router-dom";
import { Nav, Navbar, NavbarBrand, NavItem } from "reactstrap";
import { UserSearchBar } from "./UserSearchBar";

const ORIGINAL_BASE_URL = "https://kenkoooo.com/atcoder/#";

export const NavigationBar = () => {
  const [isNavigationFixed, setIsNavigationFixed] = useState(true);
  const { pathname, search, hash } = useLocation();
  const originalUrl = `${ORIGINAL_BASE_URL}${pathname}${search}${hash}`;

  return (
    <div className={isNavigationFixed ? "sticky-top" : ""}>
      <Navbar color="dark" dark expand="lg">
        <NavbarBrand tag="span" className="mb-0 h1 text-white">
          Simple AtCoder Problems
        </NavbarBrand>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <a
              href={originalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted small"
              style={{ textDecoration: "underline" }}
            >
              original page
            </a>
          </NavItem>
        </Nav>
      </Navbar>

      <Route
        path={[
          "/user/:userId([a-zA-Z0-9_]+)",
          "/table/:userId([a-zA-Z0-9_]*)?",
          "/list/:userId([a-zA-Z0-9_]*)?",
        ]}
      >
        <UserSearchBar
          isNavigationFixed={isNavigationFixed}
          setIsNavigationFixed={() => setIsNavigationFixed((e) => !e)}
        />
      </Route>
    </div>
  );
};
